

export const isMobile=(typeof window !== 'undefined') && window.screen.width< 667